import { GET_GST } from "../../../config/realstar-api-config";
import axios from "../../axios/axios";

export const fetchGSTRate = async () => {

  try {
    const response = await axios.get(`${GET_GST}`);
    
    if(response.status === 200)
    { return response.data }
    else
    { return response }
    

  } catch (error) {
    console.error('Error fetching gst data:', error);
    throw error;
  }
};